export default __webpack_public_path__ + "static/media/A_Aranha.e551270f.svg";